import { UseMutationOptions, useMutation } from '@tanstack/react-query';

import { showSuccess } from '@components/toaster';
import { useScopedTranslate } from '@locale/translate';

import { useInvalidateAuthentication } from 'api/authentication/hooks';

import { cancelDowngrade } from './requests';

export const useCancelDowngrade = (options?: UseMutationOptions<unknown, unknown, void>) => {
  const { t } = useScopedTranslate(locale);
  const { invalidateCurrentUser } = useInvalidateAuthentication();
  return useMutation({
    ...options,
    mutationFn: () => cancelDowngrade(),
    async onSuccess(data, variables, context) {
      await invalidateCurrentUser();
      await options?.onSuccess?.(data, variables, context);
      showSuccess(t('success'));
    },
  });
};

const locale = {
  en: {
    success: 'Plan downgrade cancelled',
  },
};
